import { gql } from "@apollo/client";

const GET_RELATED_LISTINGS = gql`
  query GetRelatedListings($id: Int, $uri: String, $size: Int) {
    Web {
      related(id: $id, uri: $uri, size: $size) {
        listings {
          id
          boosted
          ac
          age
          apts
          area
          backyard
          basement
          beds
          car_entrance
          category
          city_id
          create_time
          published_at
          direction_id
          district_id
          province_id
          driver
          duplex
          extra_unit
          family
          family_section
          fb
          fl
          furnished
          has_img
          imgs
          imgs_desc
          ketchen
          last_update
          refresh
          lift
          livings
          location {
            lat
            lng
          }
          maid
          men_place
          meter_price
          playground
          pool
          premium
          price
          rent_period
          rooms
          stairs
          stores
          status
          street_direction
          street_width
          tent
          trees
          type
          user_id
          user {
            phone
            name
            img
            type
            paid
            fee
            review
            iam_verified
            rega_id
            bml_license_number
            bml_url
          }
          user_type
          vb
          wc
          wells
          women_place
          has_video
          videos {
            video
            thumbnail
            orientation
          }
          verified
          special
          employee_user_id
          mgr_user_id
          unique_listing
          advertiser_type
          appraisal_id
          appraisal
          virtual_tour_link
          project_id
          approved
          gh_id
          private_listing
          blur
          location_circle_radius
          width
          length
          water_availability
          electrical_availability
          drainage_availability
          private_roof
          apartment_in_villa
          two_entrances
          special_entrance
          daily_rentable
          has_extended_details
          extended_details {
            separated_electrical_meter
            separated_water_meter
            fiber_optic
            special_parking
            ac_type
            accept_bank
            raw_land
            roof_villa
            laundry_room
            apartment_in_project
            project_name
            upper_extension
            lower_extension
            balcony
            master_bedroom
            apartments_count
            floors_count
            master_bedroom_count
            bedrooms_count
            guestsrooms_count
            driversrooms_count
            other_rooms_count
            external_area
            internal_area
            daily_renting_refundable
            daily_renting_designated_gender
            house_plan_details
            minimum_booking_days
            check_in_hour
            check_out_hour
            last_time_to_book
            is_constrained
            is_pawned
            obligations
            guarantees_and_their_duration
            saudi_code_compliance
            channels
            wifi
            washing_machine
            smart_tv
            self_entry
            oven
            sleeping
            heater
            microphone
            sound_system
            projector
            grill
            outdoor_cooling_system
            iron
            smoking
            special_view
            cleaning_service
            microwave
            shampoo
            towels
            private_beach
            cctv
            instant_booking
            insurance
            capacity
            ad_license_url
          }
          hide_contact_details
          ad_license_number
          deed_number
          rega_licensed
          published
          comments_enabled
          content
          address
          district
          direction
          city
          title
          path
          uri
          range_price
          original_range_price
        }
        title
        path
      }
    }
  }
`;

export default GET_RELATED_LISTINGS;
